import { bootstrapApplication } from '@angular/platform-browser';
import { LocaleService } from '@cmi/addin-core';
import { App } from './app/app';
import { appConfig } from './app/app.config';

function boot(): Promise<void> {
  const replaceState = window.history.replaceState.bind(window.history);
  const pushState = window.history.pushState.bind(window.history);

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js';

    script.onload = (): void => {
      void Office.onReady(({ host }): void => {
        window.history.replaceState = replaceState;
        window.history.pushState = pushState;

        if (host) {
          resolve();
        } else {
          reject(new Error('The application has to run from within Office'));
        }
      });
    };

    document.body.appendChild(script);
  });
}

void boot().then(async (): Promise<void> => {
  const appRef = await bootstrapApplication(App, appConfig);
  const localeService = appRef.injector.get(LocaleService);
  await localeService.loadTranslations();
});
